import { render } from "./ValidateTabletFormComponent.vue?vue&type=template&id=4995d444"
import script from "./ValidateTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./ValidateTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__